"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class CommunicationService {
    constructor(eventId) {
        this._globalWindow = nodejs_library_1.Helpers.EnvironmentHelper.isClientSide() && window || {};
        this._eventId = eventId;
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            if (!(this._globalWindow[eventId] instanceof rxjs_1.BehaviorSubject)) {
                this._globalWindow[eventId] = new rxjs_1.BehaviorSubject(null);
            }
        }
    }
    emitEvent(payload) {
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            const bs = this._globalWindow[this._eventId];
            bs === null || bs === void 0 ? void 0 : bs.next(payload);
        }
    }
    getObservable() {
        // TO-DO Da testare
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            const bs = this._globalWindow[this._eventId];
            return (bs === null || bs === void 0 ? void 0 : bs.pipe((0, operators_1.filter)((x) => x !== null))) || rxjs_1.EMPTY;
        }
        else {
            return rxjs_1.EMPTY;
        }
    }
    destroy() {
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            const bs = this._globalWindow[this._eventId];
            bs === null || bs === void 0 ? void 0 : bs.unsubscribe();
        }
    }
}
exports.CommunicationService = CommunicationService;
